import { render, staticRenderFns } from "./michaelsen.vue?vue&type=template&id=934b1e9c&scoped=true&"
import script from "./michaelsen.vue?vue&type=script&lang=js&"
export * from "./michaelsen.vue?vue&type=script&lang=js&"
import style0 from "./michaelsen.vue?vue&type=style&index=0&id=934b1e9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934b1e9c",
  null
  
)

export default component.exports